/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { SelectItem } from 'primeng/api';

/*
 * Converts an object to a format compatible with PrimeNG's Dropdown component SelectItems,
 * mapping the object properties to the keys of the selectItem and their value to the selectItems' values.
 *
 * Useful when receiving a java Map object automatically serialized by a controller method on the server.
 * (Map is serialized to a simple JSON object).
 *
 * Usage:
 *  array | formatSelectItem:'Description':'Key'"
 * Example:
 *  dict[{id: 1, name: 'name'}] | formatSelectItem:'id':'name'
 *  formats to: [{ value: '1' , label: 'name'}]
 */

@Pipe({ name: 'objectToSelectItems', })
@Injectable()
export class ObjectToSelectItemListPipe implements PipeTransform {
  transform(value: object): Array<SelectItem> {
    if (value) {
      return Object.keys(value).map(function (key) {
        return {
          value: value[key],
          label: key,
        };
      });
    }
    return [];
  }
}
